import { useEffect, useState } from 'react';
import { MenuSelect } from '@/pages/reports/ats-reports/components/menu-select';

const options = [
  { id: 'overall', label: 'Overall rate' },
  { id: 'passthrough', label: 'Pass through rate' },
];

export const Metrics = ({
  onChange = () => {},
  selected = null,
  isEditMode = false,
  isPortal = false,
}) => {
  const [currSelected, setSelected] = useState(options[0]);

  const onSelect = (option) => {
    setSelected(option);
    onChange(option);
  };

  useEffect(() => {
    if (selected) {
      const currSelected = options?.find((option) => option.id === selected);
      setSelected(currSelected);
    }
  }, [selected]);

  return (
    <MenuSelect
      editMode={isEditMode}
      options={options}
      selected={currSelected}
      onSelect={onSelect}
      prefix="Metrics"
      isPortal={isPortal}
    />
  );
};
